import React from 'react';

const PracticeDashboardTabPane = ({ tabId, activeTab, mountedTabs, children }) => {
  if (!mountedTabs.has(tabId)) {
    return null;
  }

  const isActive = activeTab === tabId;

  return (
    <div
      className="practice-dashboard-tab-pane"
      hidden={!isActive}
      aria-hidden={!isActive}
    >
      {children}
    </div>
  );
};

export default PracticeDashboardTabPane;
